module.exports = __webpack_public_path__ + "static/img/104142.c8abccc8.png";